import { z } from 'zod';
import { dateOnly, timeOnly } from './common.js';
/**
 * Слоты доставки.
 *
 * Сетка НЕ материализуется в таблицу: она вычисляется из настроек, а занятость
 * считается запросом к заказам. Так изменение рабочих часов не требует
 * регенерации будущих слотов и не расходится с уже принятыми заказами.
 */
/** Почему слот недоступен. Клиент должен понимать, отчего время серое. */
export const slotUnavailableReason = z.enum([
    'lead_time', // до начала осталось меньше лид-тайма
    'full', // набрана вместимость
    'closed', // день закрыт администратором
    'past', // слот уже прошёл
]);
export const slot = z.object({
    start: timeOnly,
    end: timeOnly,
    available: z.boolean(),
    reason: slotUnavailableReason.nullable(),
    /** Сколько мест осталось. Показывать необязательно, но полезно админу. */
    left: z.number().int().min(0),
});
export const slotDay = z.object({
    date: dateOnly,
    slots: z.array(slot),
});
export const slotsQuery = z.object({
    date_from: dateOnly.optional(),
    days: z.coerce.number().int().min(1).max(30).optional(),
});
export const slotsResponse = z.object({
    days: z.array(slotDay),
    timezone: z.string(),
});
// ── Настройки (админка) ─────────────────────────────────────────────────────
export const slotSettings = z.object({
    work_start: timeOnly,
    work_end: timeOnly,
    slot_minutes: z.number().int().min(15).max(720),
    capacity_per_slot: z.number().int().min(1).max(1000),
    lead_time_minutes: z.number().int().min(0).max(10080),
    horizon_days: z.number().int().min(1).max(30),
    timezone: z.string().min(1).max(64),
});
export const updateSlotSettingsBody = slotSettings.partial().refine((v) => !v.work_start || !v.work_end || v.work_start < v.work_end, { message: 'Начало рабочего дня должно быть раньше конца', path: ['work_start'] });
export const slotException = z.object({
    id: z.number().int().positive(),
    slot_date: dateOnly,
    is_closed: z.boolean(),
    reason: z.string().nullable(),
});
export const createSlotExceptionBody = z.object({
    slot_date: dateOnly,
    is_closed: z.boolean().default(true),
    reason: z.string().max(200).nullable().optional(),
});
//# sourceMappingURL=slot.js.map